(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dwg-added-to-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    const COMPONENT_TAG = 'dwg-added-to-cart-component';
    const root = document.getElementById('dwg-added-to-cart');
    if (!root) return;

    const overlay = root.querySelector('.dwg-atc__overlay');
    const dialog = root.querySelector('.dwg-atc__dialog');
    const productTitleEls = root.querySelectorAll('[data-dwg-atc-product-title], [data-dwg-atc-product-title-large]');
    const productImageEl = root.querySelector('[data-dwg-atc-product-image]');
    const productPriceEl = root.querySelector('[data-dwg-atc-product-price]');
    const cartCountEl = root.querySelector('[data-dwg-atc-cart-count]');
    const upsellWrap = root.querySelector('[data-dwg-atc-upsell]');
    const upsellList = root.querySelector('[data-dwg-atc-upsell-list]');
    const dismissEls = root.querySelectorAll('[data-dwg-atc-dismiss]');

    const moneyFormat = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';

    function formatMoney(cents) {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: moneyFormat }).format(cents / 100);
      } catch (e) {
        return '£' + (cents / 100).toFixed(2);
      }
    }

    function open() {
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    dismissEls.forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    /**
     * Populate modal from a cart item object (Shopify cart line item shape).
     */
    function populate(item, cart) {
      const title = item.product_title || item.title || '';
      productTitleEls.forEach((el) => { el.textContent = title; });
      if (productImageEl) {
        if (item.featured_image && item.featured_image.url) {
          productImageEl.src = item.featured_image.url;
          productImageEl.alt = title;
        } else if (item.image) {
          productImageEl.src = item.image;
          productImageEl.alt = title;
        }
      }
      if (productPriceEl) {
        const price = (item.final_price != null ? item.final_price : item.price) || 0;
        productPriceEl.textContent = formatMoney(price);
      }
      if (cartCountEl && cart && typeof cart.item_count === 'number') {
        cartCountEl.textContent = String(cart.item_count);
      }

      // Cross-sells via Shopify recommendations
      const productId = item.product_id;
      if (productId) loadUpsells(productId);
    }

    function loadUpsells(productId) {
      const url = '/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=3&intent=related';
      fetch(url, { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.json() : null))
        .then((data) => {
          if (!data || !Array.isArray(data.products) || data.products.length === 0) {
            upsellWrap.hidden = true;
            return;
          }
          renderUpsells(data.products.slice(0, 3));
          upsellWrap.hidden = false;
        })
        .catch(() => {
          upsellWrap.hidden = true;
        });
    }

    function renderUpsells(products) {
      upsellList.innerHTML = '';
      products.forEach((p) => {
        const li = document.createElement('li');
        li.className = 'dwg-atc__upsell-card';
        const img = document.createElement('img');
        img.className = 'dwg-atc__upsell-card-img';
        img.alt = '';
        img.loading = 'lazy';
        img.src = (p.featured_image || (p.images && p.images[0]) || '');
        const info = document.createElement('div');
        info.className = 'dwg-atc__upsell-card-info';
        const t = document.createElement('span');
        t.className = 'dwg-atc__upsell-card-title';
        t.textContent = p.title;
        const pr = document.createElement('span');
        pr.className = 'dwg-atc__upsell-card-price';
        pr.textContent = formatMoney(p.price);
        info.appendChild(t);
        info.appendChild(pr);
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'dwg-atc__upsell-card-add';
        btn.textContent = 'Add';
        btn.setAttribute('data-variant-id', String((p.variants && p.variants[0] && p.variants[0].id) || ''));
        btn.addEventListener('click', function () {
          const variantId = btn.getAttribute('data-variant-id');
          if (!variantId) return;
          btn.disabled = true;
          btn.textContent = 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
            credentials: 'same-origin',
          })
            .then((r) => r.json())
            .then(() => fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json()))
            .then((cart) => {
              const lastItem = cart.items[cart.items.length - 1];
              populate(lastItem, cart);
              btn.disabled = false;
              btn.textContent = 'Add';
              // Notify other components (cart drawer/icon) to update
              try {
                const evt = new CustomEvent('cart:update', { detail: { resource: cart, source: 'dwg-atc' } });
                document.dispatchEvent(evt);
              } catch (e) {}
            })
            .catch(() => {
              btn.disabled = false;
              btn.textContent = 'Add';
            });
        });
        li.appendChild(img);
        li.appendChild(info);
        li.appendChild(btn);
        upsellList.appendChild(li);
      });
    }

    /**
     * Detect whether the cart-add originated from a "Recommended products"
     * section. We only show this modal in that case — main product-page
     * Add-to-cart keeps its existing cart drawer behavior.
     */
    function isFromRecommendations(eventTarget) {
      if (!eventTarget || typeof eventTarget.closest !== 'function') return false;
      // The CartAddEvent bubbles up from <product-form-component>; .closest finds
      // the enclosing Shopify section element. Recommendations sections render
      // with type "product-recommendations" and an id like
      // "shopify-section-template--XXX__product_recommendations".
      const section = eventTarget.closest('.shopify-section');
      if (!section) return false;
      if (section.id && section.id.indexOf('product_recommendations') !== -1) return true;
      // Some themes use a custom element <product-recommendations> inside the section
      if (section.querySelector('product-recommendations, product-recommendations-component')) return true;
      return false;
    }

    /**
     * Hook into the theme's cart-add events. Horizon emits 'cart:update'
     * (both CartAddEvent and CartUpdateEvent share that type). We only act
     * when the source is a Recommended products section.
     */
    function handleCartUpdate(e) {
      const detail = (e && e.detail) || {};
      // Avoid loops from our own internal upsell-add inside the modal
      if (detail.source === 'dwg-atc' || (detail.data && detail.data.source === 'dwg-atc')) return;
      if (!isFromRecommendations(e.target)) return;

      const cart = detail.resource || detail.cart;
      if (!cart) {
        // fallback: fetch cart fresh
        fetch('/cart.js', { credentials: 'same-origin' })
          .then((r) => r.json())
          .then((freshCart) => {
            if (freshCart && freshCart.items && freshCart.items.length) {
              populate(freshCart.items[freshCart.items.length - 1], freshCart);
              open();
            }
          })
          .catch(() => {});
        return;
      }
      if (!cart.items || cart.items.length === 0) return;
      const lastItem = cart.items[cart.items.length - 1];
      populate(lastItem, cart);
      open();
    }

    // Listen on document and window — Horizon dispatches differently in places.
    document.addEventListener('cart:update', handleCartUpdate);
    window.addEventListener('cart:update', handleCartUpdate);

    /**
     * Suppress the cart drawer auto-open ONLY when the add came from a
     * recommendations section (so main product-page Add-to-cart still
     * opens the drawer as expected).
     */
    function suppressCartDrawer() {
      const drawer = document.querySelector('cart-drawer-component, [is="cart-drawer-component"]');
      if (!drawer) return;
      const dialog = drawer.querySelector('dialog');
      if (dialog && typeof dialog.close === 'function') {
        try { dialog.close(); } catch (e) {}
      }
    }
    document.addEventListener('cart:update', function (e) {
      if (!isFromRecommendations(e.target)) return;
      // Defer so we run after the drawer's own listener has opened it.
      setTimeout(suppressCartDrawer, 0);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dwg-welcome-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    var banner = document.getElementById('dwg-welcome-banner');
    if (!banner) return;

    var SESSION_KEY = 'dwg-welcome-banner-session-dismissed';
    var PERMANENT_KEY = 'dwg-welcome-banner-signed-up';
    var PAGEVIEWS_KEY = 'dwg-welcome-banner-page-views';
    // Strategic show schedule (page views in the current session).
    // The banner appears the first time, again after a bit of browsing,
    // and once more for engaged users — capped at 3 shows per session.
    var SHOW_AT_PAGEVIEWS = [1, 4, 8];
    var SHOW_DELAY_MS = 1500;
    var CLOSE_TRANSITION_MS = 320;
    var dismissEls = banner.querySelectorAll('[data-dwg-dismiss]');
    var dismissSessionEls = banner.querySelectorAll('[data-dwg-dismiss-session]');
    var justSubmitted = banner.getAttribute('data-just-submitted') === 'true';

    function isPermanentlyDismissed() {
      try { return window.localStorage.getItem(PERMANENT_KEY) === '1'; } catch (e) { return false; }
    }

    function isSessionDismissed() {
      try { return window.sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) { return false; }
    }

    function rememberPermanent() {
      try { window.localStorage.setItem(PERMANENT_KEY, '1'); } catch (e) {}
    }

    function rememberSession() {
      try { window.sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
    }

    function incrementPageViews() {
      try {
        var current = parseInt(window.sessionStorage.getItem(PAGEVIEWS_KEY) || '0', 10) || 0;
        var next = current + 1;
        window.sessionStorage.setItem(PAGEVIEWS_KEY, String(next));
        return next;
      } catch (e) { return 1; }
    }

    function shouldShowAtPageView(n) {
      for (var i = 0; i < SHOW_AT_PAGEVIEWS.length; i++) {
        if (SHOW_AT_PAGEVIEWS[i] === n) return true;
      }
      return false;
    }

    function show() {
      banner.classList.add('is-visible');
      document.documentElement.style.overflow = 'hidden';
    }

    function hide() {
      // Plain dismiss — does NOT persist. Pop-up returns on next page load.
      banner.classList.remove('is-visible');
      document.documentElement.style.overflow = '';
      setTimeout(function () {
        banner.style.display = 'none';
      }, CLOSE_TRANSITION_MS);
    }

    function dismissForSession() {
      rememberSession();
      hide();
    }

    // Skip rendering if user already signed up (permanent) or chose
    // "Don't Show Me Again" this session.
    if ((isPermanentlyDismissed() || isSessionDismissed()) && !justSubmitted) {
      banner.style.display = 'none';
      return;
    }

    // Strategic show throttle: count every page view in this session
    // and only show on pre-defined trigger views (e.g. 1st, 4th, 8th).
    // After 3 shows in a session, the banner stays hidden for that session
    // even if the user keeps browsing.
    var pageViews = incrementPageViews();
    if (!justSubmitted && !shouldShowAtPageView(pageViews)) {
      banner.style.display = 'none';
      return;
    }

    // Plain dismissals (X / NO THANKS / overlay click)
    dismissEls.forEach(function (el) {
      el.addEventListener('click', hide);
    });

    // Session-dismissal button ("DON'T SHOW ME AGAIN")
    dismissSessionEls.forEach(function (el) {
      el.addEventListener('click', dismissForSession);
    });

    // ESC closes (no persistence)
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && banner.classList.contains('is-visible')) {
        hide();
      }
    });

    function reveal() {
      window.requestAnimationFrame(function () {
        setTimeout(show, SHOW_DELAY_MS);
      });
    }

    /* Silently apply the WELCOME10 discount to the user's cart session.
       Shopify's /discount/CODE endpoint applies the code as a server-side
       cart attribute and then redirects. fetch() with default redirect
       behavior + no-cors mode is enough to trigger the apply without
       navigating away from this page. */
    function applyWelcomeDiscount() {
      try {
        fetch('/discount/WELCOME10', { credentials: 'same-origin', mode: 'no-cors' })
          .catch(function () {});
      } catch (e) {}
    }

    /* Click-to-copy the discount code in the reward modal. Binds both the
       code text itself and the "COPY DISCOUNT CODE" button. */
    var COPY_CODE = 'WELCOME10';
    var copyEls = banner.querySelectorAll('[data-dwg-copy-code]');
    copyEls.forEach(function (el) {
      el.addEventListener('click', function () {
        var clickedBtn = el;
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(COPY_CODE);
          } else {
            var ta = document.createElement('textarea');
            ta.value = COPY_CODE;
            ta.setAttribute('readonly', '');
            ta.style.position = 'absolute';
            ta.style.left = '-9999px';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
          }
          var original = clickedBtn.textContent;
          clickedBtn.textContent = 'COPIED!';
          setTimeout(function () { clickedBtn.textContent = original; }, 1500);
        } catch (e) {}
      });
    });

    if (justSubmitted) {
      // Successful signup: persist permanently so it never returns.
      rememberPermanent();
      // Apply the 10% discount to the user's cart in the background, so
      // even if the user just dismisses without clicking Apply, their cart
      // already has the code on it.
      applyWelcomeDiscount();
      show();
      // No auto-close for the reward — user dismisses manually via X /
      // overlay / Esc, or by clicking Copy/Apply.
    } else if (document.readyState === 'complete' || document.readyState === 'interactive') {
      reveal();
    } else {
      window.addEventListener('DOMContentLoaded', reveal);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
